import React from "react";
import { Box, Typography } from "@mui/material";
import PolicyBarChart from "./PolicyBarChart";
import InfoTooltip from "./CountyCommodityMap/InfoTooltip";
import { BRAND_GREEN } from "../shared/colors";

interface PolicyComparisonSectionProps {
    currentData: any;
    proposedData: any;
    title?: string;
    chartTitle?: string;
    subTitle?: string;
    tooltip?: string;
    enableScenarioSwitching?: boolean;
    currentLabel?: string;
    proposedLabel?: string;
    chartCurrentLabel?: string;
    chartProposedLabel?: string;
}

export default function PolicyComparisonSection({
    currentData,
    proposedData,
    title = "Policy Impact Comparison",
    chartTitle,
    subTitle,
    tooltip,
    enableScenarioSwitching = true,
    currentLabel = "Current Policy",
    proposedLabel = "Proposed Policy",
    chartCurrentLabel = "C",
    chartProposedLabel = "P"
}: PolicyComparisonSectionProps): JSX.Element {
    const chartData = {
        current: currentData,
        proposed: proposedData
    };
    return (
        <Box>
            <Typography
                sx={{
                    fontWeight: 600,
                    fontSize: "1.5rem",
                    color: BRAND_GREEN,
                    mb: 1,
                    textAlign: "center"
                }}
            >
                {title}
                {tooltip && <InfoTooltip title={tooltip} />}
            </Typography>
            {subTitle && (
                <Box>
                    <Typography
                        sx={{
                            fontSize: "0.875rem",
                            color: BRAND_GREEN,
                            fontWeight: "bold",
                            mb: 1,
                            textAlign: "center"
                        }}
                    >
                        {subTitle}
                    </Typography>
                </Box>
            )}

            <Typography
                sx={{
                    fontSize: "0.875rem",
                    color: "#666",
                    fontStyle: "italic",
                    mb: 1,
                    textAlign: "center"
                }}
            >
                {enableScenarioSwitching
                    ? `Click commodity checkboxes to filter view (at least one must be selected). Hover over bars for detailed breakdown. ${chartCurrentLabel} = ${currentLabel}, ${chartProposedLabel} = ${proposedLabel}.`
                    : `Click commodity checkboxes to filter view (at least one must be selected). Hover over bars for detailed breakdown. ${chartCurrentLabel} = ${currentLabel}, ${chartProposedLabel} = ${proposedLabel}.`}
            </Typography>
            <Box sx={{ width: "100%" }}>
                <PolicyBarChart
                    title={chartTitle}
                    data={chartData}
                    width={undefined}
                    height={450}
                    margin={{ top: 50, right: 80, bottom: 40, left: 80 }}
                    currentLabel={currentLabel}
                    proposedLabel={proposedLabel}
                    chartCurrentLabel={chartCurrentLabel}
                    chartProposedLabel={chartProposedLabel}
                />
            </Box>
        </Box>
    );
}
